var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKuvaSymbolRev = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF5100;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72,0C32.24,0,0,32.24,0,72c0,39.76,32.24,72,72,72s72-32.24,72-72C144,32.24,111.76,0,72,0z M72,110.29 c-21.15,0-38.29-17.14-38.29-38.29c0-21.15,17.14-38.29,38.29-38.29S110.29,50.85,110.29,72C110.29,93.15,93.15,110.29,72,110.29z "
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.86,
    cy: 72,
    r: 16.86
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKuvaSymbolRev);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Kuva_Symbol_Rev.06da0a94131cf03bf4d0c8d9689ff655.svg";